import { PropsWithChildren } from 'react';

import './styles.css';

export const StylesProvider = ({ children }: PropsWithChildren) => (
  <div className="mtw">{children}</div>
);
